
import AdminHome from "./home";


if (document.body.getAttribute("data-current-path") === "admin/pages") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new AdminHome();
    }
}